import { graphql } from "~/gql";

export const TEXT_FILTER_MATTERS = graphql(/* GraphQL */ `
  query TextFilterMatters($filter: textFilterArg!) {
    textFilteredMatters(filter: $filter) {
      total
      matters {
        __typename
        id
        title
        client {
          id
          name
        }
      }
    }
  }
`);
